export default "__VITE_ASSET__BIqmjM_3__"